// @ts-strict-ignore
import type { useSnackBar } from '@usealloy/component-library';
import type React from 'react';

import type { Action } from 'flow/store/engine/types';
import type { DropdownItem } from 'flow/editor/components/Graph/nodes/BaseNode/NodeDropdownMenu';
import { /* OnCopyDefaults, */ OnDeleteDefaults } from 'flow/editor/components/Graph/nodes/BaseNode/NodeDropdownMenu';
import {
  increaseActionPrecedenceThunk,
  setExistingPrecedenceIndexedActionAsDefaultThunk,
} from 'flow/store/redux/thunks';
import {
  isDefaultPrecedenceIndexedAction,
  isActionOfHighestPrecedence,
} from 'flow/service/actions';
import type { NodeState } from 'flow/service/graph';
import type { WorkflowState } from 'flow/store/redux/state';

import type { AppDispatch } from '~/store';

import { ActionType } from '~/dashboard/views/workflows/store/engine/constants';


export function getNodeStateStyle(
  nodeState: NodeState): React.CSSProperties {
  return {
    deemphasized: {},
    faded: {},
    floated: {},
    focused: {},
    'focused-hovered': {
    },
    highlighted: {},
    hovered: {
      backgroundColor: 'var(--cl-gray-400)',
    },
    normal: {},
  }[nodeState];
}

export function getDropdownItems({
  addSnackBar,
  dispatch,
  action,
  allActionsOfActionType,
  workflowData,
  setNodeDeletionChildActionCounts,
  onSwapOutcome,
  isWorkflowHistoryOn,
  // workflowProps,
}: {
  addSnackBar: ReturnType<typeof useSnackBar>;
  dispatch: AppDispatch;
  action: Action;
  allActionsOfActionType: Action[];
  workflowData: WorkflowState['workflowData'];
  workflowProps: WorkflowState['workflowProps'];
  setNodeDeletionChildActionCounts: React.Dispatch<React.SetStateAction<number>>;
  onSwapOutcome: () => void;
  isWorkflowHistoryOn: boolean;
}): DropdownItem[] {
  const { publicId: nodeId } = action;
  const isTopMostWorkflowRoutingAction = isActionOfHighestPrecedence(
    workflowData.actions,
    action,
    ActionType.WORKFLOW,
  );

  const isDefault = isDefaultPrecedenceIndexedAction(action);

  return [
    {
      label: 'Swap outcome',
      onSelect: onSwapOutcome,
      disabled: allActionsOfActionType?.length <= 1,
    },
    {
      label: 'Increase precedence',
      onSelect: () => {
        dispatch(increaseActionPrecedenceThunk(action));
      },
      disabled: isTopMostWorkflowRoutingAction || isDefault,
    },
    {
      label: 'Make default',
      onSelect: () => {
        dispatch(setExistingPrecedenceIndexedActionAsDefaultThunk(action));
      },
      disabled: isDefault,
    },
    {
      disabled: (isDefault && allActionsOfActionType?.length > 1),
      Icon: OnDeleteDefaults.Icon,
      label: OnDeleteDefaults.label,
      onSelect: OnDeleteDefaults.onSelect({
        addSnackBar,
        dispatch,
        isWorkflowHistoryOn,
        nodeId,
        workflowData,
        setNodeDeletionChildActionCounts,
      }),
      style: OnDeleteDefaults.style,
    },
  ];
}
